import { TRUNCATE_ATTR } from "../TruncatedText/truncation";

const TOOLTIP_TRIGGER_ATTR = "data-c6-tooltip-trigger";

// Tooltip 자체 trigger와 잘림 marker 외에도, 버블 아래에서 사용자가 곧바로 조작하려는 표준
// interactive target을 찾는다. role=option은 dropdown/search 같은 선택 컨트롤을 포함한다.
const COMPETING_POINTER_TARGET_SELECTOR = [
  `[${TOOLTIP_TRIGGER_ATTR}]`,
  `[${TRUNCATE_ATTR}]`,
  "a[href]",
  "button",
  "input",
  "select",
  "textarea",
  "summary",
  "label",
  "[contenteditable]:not([contenteditable='false'])",
  "[tabindex]",
  "[role='button']",
  "[role='checkbox']",
  "[role='combobox']",
  "[role='gridcell']",
  "[role='link']",
  "[role='menuitem']",
  "[role='menuitemcheckbox']",
  "[role='menuitemradio']",
  "[role='option']",
  "[role='radio']",
  "[role='slider']",
  "[role='spinbutton']",
  "[role='switch']",
  "[role='tab']",
  "[role='textbox']",
  "[role='treeitem']",
].join(",");

interface TooltipPointerTargetOptions {
  bubble: HTMLElement;
  trigger: HTMLElement;
  clientX: number;
  clientY: number;
}

/**
 * 포인터 위치에서 Tooltip bubble 아래에 **다른** hover/interactive target이 있는지 찾는다.
 *
 * bubble은 WCAG 1.4.13 hoverable을 위해 pointer-events:auto지만, dense list처럼 bubble이 이웃
 * option 위를 덮으면 그 pointer-events가 콘텐츠 탐색을 가로챈다. 이 경우에만 bubble을 즉시 닫고,
 * 그 외에는 기존 hover bridge를 유지한다.
 */
export function isTooltipBubbleBlockingPointerTarget({
  bubble,
  trigger,
  clientX,
  clientY,
}: TooltipPointerTargetOptions): boolean {
  if (typeof document.elementsFromPoint !== "function") return false;

  return document.elementsFromPoint(clientX, clientY).some((element) => {
    const candidate = element.closest<HTMLElement>(COMPETING_POINTER_TARGET_SELECTOR);
    if (!candidate) return false;

    // bubble content나 현재 trigger(및 ListView option 같은 현재 trigger의 interactive 조상)는
    // 경쟁 대상이 아니다. 서로 관계없는 target만 접근을 돌려줘야 할 대상이다.
    if (bubble.contains(candidate)) return false;
    if (trigger.contains(candidate) || candidate.contains(trigger)) return false;

    return true;
  });
}
